import { render } from "./GenerateToken.vue?vue&type=template&id=29da9026&scoped=true&ts=true"
import script from "./GenerateToken.vue?vue&type=script&lang=ts"
export * from "./GenerateToken.vue?vue&type=script&lang=ts"

import "./GenerateToken.vue?vue&type=style&index=0&id=29da9026&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29da9026"]])

export default __exports__